import { com } from '@eidu/web'
import { Checkbox, Group, TextInput, UnlabeledField } from '@common/ui'
import React from 'react'
import EntityTypeDisplay from './EntityTypeDisplay'
import EntityType = com.eidu.entity.type.EntityType
import FieldType = com.eidu.entity.field.FieldType
import Field = com.eidu.entity.field.Field

const isReference = (fieldType: FieldType) => fieldType === FieldType.Reference

export type FieldDisplayProps = {
  availableEntityTypes: readonly EntityType[]
  field: Field
}

const FieldDisplay = ({ availableEntityTypes, field }: FieldDisplayProps) => {
  // Find entity type names for reference types
  const referenceTypes = field.validReferenceTypes?.asJsReadonlySetView()?.let((it) => Array.from(it)) || []

  const idPrefix = `field-${field.id.toString()}`

  return (
    <>
      <Group align="flex-start" wrap="nowrap">
        <TextInput
          label={field.name}
          id={`${idPrefix}-display-${field.name}`}
          value={field.type.name}
          style={{ flex: 1 }}
          disabled
          readOnly
        />
        <UnlabeledField pl="md" style={{ flex: 1 }}>
          <Checkbox checked={field.required} disabled label="Required" />
        </UnlabeledField>
      </Group>
      {isReference(field.type) && (
        <Group mt="lg" wrap="nowrap">
          <div style={{ flex: 0.1 }} />
          <div style={{ flex: 0.9 }}>
            <EntityTypeDisplay
              label={`Valid types for ${field.name}`}
              labelId={`${idPrefix}-reftype-${field.name}`}
              availableEntityTypes={availableEntityTypes}
              selectedEntityTypes={referenceTypes}
            />
          </div>
          <div style={{ flex: 1, paddingLeft: 16 }} />
        </Group>
      )}
    </>
  )
}

export default FieldDisplay
